import { Component, OnInit } from '@angular/core';
import { EVENTS, IMAGE } from 'src/app/config';
import { ApiService } from 'src/app/api.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-events',
    templateUrl: './events.component.html',
    styleUrls: ['./events.component.css'],
    
})
export class EventsComponent implements OnInit {
  events: [];
  url: any;
    current_page: any;
    pages: number;
    constructor(private api: ApiService,private router: Router,private route: ActivatedRoute) {
        this.route.queryParamMap.subscribe(params =>{
          this.current_page = params.get('page');
          this.current_page = Number(this.current_page);
          this.getEvent(this.current_page);
        });
  
    }

    pagechanged(){
      this.router.navigate(['events'], { queryParams: { page: this.current_page}});
    }
  
    getEvent(page){
      this.api.Get(EVENTS+'?page='+page).then(data => {
        this.events = data['data']['data'];
        this.url = IMAGE+"events/";
        this.pages = Math.ceil(data['data']['total']/16);
        //this.pages=20;
      }).catch(d=>{
        if(d.status == 503){
          this.api.onFail('Your session is expired please login again','Login');
          this.api.setGoto();
          this.api.setlogin(0);
          this.api.logout();
          setTimeout(() => {
          this.router.navigate(['/login']);
          },1000);
        } else{console.log(d)}
      });
    }
  
    detail(value) {
      this.router.navigate(['/event', value.id]);
    }
    ngOnInit(): void {
    }
  
  }
